import script from "./asLeads.vue?vue&type=script&lang=ts&setup=true"
export * from "./asLeads.vue?vue&type=script&lang=ts&setup=true"

import "./asLeads.vue?vue&type=style&index=0&id=38db32a6&lang=less&scoped=true"

import exportComponent from "/builds/26732/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38db32a6"]])

export default __exports__